var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"bg-white",attrs:{"fluid":""}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('b-form-input',{attrs:{"placeholder":"Search...","value":_vm.keyword,"disabled":_vm.loading},on:{"keyup":_vm.updateSearchQuery,"blur":_vm.updateSearchQuery}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }